import {
  Component,
} from '@angular/core';
import {DetailScreenComponent} from '../detail-screen/detail-screen.component';
import {DetailScreensService} from '../services/detail-screens-service';
import {PopupService} from '../../popup-component/popup.service/popup.service';
import {URL_BOC,URL_GELDOVER} from './detail-button.constants';
import {ProductOverviewRequest} from '../../../../services/product-overview/product-overview-request.model';

@Component({
  selector: 'app-details-button',
  templateUrl: './detail-button.component.html',
  styleUrls: ['../detail-screen/detail-screen.component.css'],
})

export class DetailButtonComponent {
  name: string;
  id: string;
  label: string;
  tokenSort: string;
  url: string;
  icon: string;
  arrangementNumber;
  administrationCode;
  commercialProductTypeCode;
  parent: DetailScreenComponent;
  data: any;

  constructor(private detailScreenService: DetailScreensService, private popupService: PopupService) {
    this.icon = 'rds-icon-bell';
  }

  setName() {
    switch (this.id) {
      case 'productservicesurl':
        this.name = this.label || 'Product services';
        break;
      case 'cockpiturl':
      case 'icmasbabonnement':
        this.name = this.label || 'B&O Cockpit';
        this.icon = 'betalen-managen-geldstromen';
        break;
      case 'boc':
        this.name = 'BOC';
        break;
      case 'geldOverPortaalurl':
        this.name = 'Medewerkers App Geld Over';
        break;
      default:
        break;
    }
  }

  setToken(token: string) {
   this.tokenSort = token || undefined;
  }

  setUrl(url: string) {
    this.url = url;
  }

  setData(data: any) {
    this.data = data;
  }

  onClick() {
    const requiredRequestData = {
      arrangementNumber: this.arrangementNumber,
      administrationCode: this.administrationCode,
      relationRestrictedDataView: true,
      restrictedDataViewException: false,
      commercialProductTypeCode: this.commercialProductTypeCode,
      parametersToken: ProductOverviewRequest.parametersToken,
      orgYN: ProductOverviewRequest.orgYN,
    };

    const buttonUrlRequestBody = {
      url: this.url,
      arrangementNumber: this.arrangementNumber,
      administrationCode: this.administrationCode,
      commercialProductTypeCode: this.commercialProductTypeCode,
      tokenSort: this.tokenSort,
      data: this.data,
    };

    if (this.id === 'productservicesurl') {
      this.popupService.openPopup('productservices', requiredRequestData);
    } else if (this.id === 'icmasbabonnement') {
      window.open(this.url, '_blank');
    } else if (this.id === 'cockpiturl') {
      this.detailScreenService.getButtonUrl(buttonUrlRequestBody)
        .subscribe(
          (res) => {
            if (res.listOfError && res.listOfError.length) {
              window.open(URL_BOC, '_blank');
              return;
            }
            this.redirectToUrl(res);
          },
          () => {
            if (this.url === 'boc-url') {
              window.open(URL_BOC, '_blank');
            }
          },
        );
    } else if(this.id === 'geldOverPortaalurl') {
        window.open(URL_GELDOVER + this.data, '_blank');
    }
  }

  redirectToUrl(res) {
    const url = res.psUrl ? res.psURL : res.url;
    const decodedUrl = atob(url);
    window.open(decodedUrl, '_blank');
  }

}
